export { default } from './JsonLD';
